import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  flow,
  types,
  getRoot,
} from 'mobx-state-tree';

import get from 'lodash/get';

import UserModel from 'models/user-model';

import { getGlobalStore } from 'stores';
import { request, debug, track, utils, globalPageConfig } from 'lib';
import { getStore } from './index';
import { getRtcStore } from 'widgets/lib/rtc/store';

const log = debug.create('room');
const error = debug.create('room:error');

const initState = {
  roomId: 0,
  allRoomInfo: {},
  starInfo: {
    _id: 0,
  },
  roomInfo: {},
  liveType: {},
};

const RewardModel = types.model('RewardModel', {});

// 特权推荐
const RecommModel = types.model('RecommModel', {});

const PkModel = types.model('PkModel', {});

const PullUrlModel = types.model('PullUrl', {
  rtmp_url: '',
  hls_url: '',
  flv_url: '',
});
const LiveStreamModel = types
  .model('LiveStreamModel', {
    uid: 0,
    pull_urls: PullUrlModel,
    v_type: 0, //

    voice_chat_index: 0,
    voice_chat_join_time: 0,
    nickname: '',
    pic: '',
    voice: true,
  })
  .views((self) => {
    return {
      // get pkInfo() {
      //   const res =  getRoot(self).lianmai.joinLine.info.mode_info.getRoomPkInfo(self.uid);
      //   console.log('pkInfo', self.uid, res);
      //   return res;
      // }
    };
  });

const CertificationsModel = types.model('CertificationsModel', {
  certification_type: '',
  level: 0,
  level_name: '',
  type_name: '',
});

const RoomInfoModel = types.snapshotProcessor(
  types
    .model('RoomInfoModel', {
      _id: 0,
      apply_type: 0,
      found_time: 0,
      live: false,
      temp: false,
      type: 0,
      visiter_count: 0,
      labels: types.maybeNull(types.array(types.string)),
      audit_app_pic_status: 0,
      audit_app_pic_reason: types.maybeNull(types.string),
      audit_app_pic_url: '',
      app_pic_url: '', // 主播封面  全部使用app_pic_url字段，统一成和客户端一致
      live_id: '',
      live_type: 0, // 1 在pc开播，2 在手机开播
      plugin: 0,
      // position:,
      timestamp: 0, // 开播时间
      v_type: 0,
      total_live_sec_time: 0,
      followers: 0, // 关注数
      found_time_str: '',
      stream_id: types.maybeNull(types.string), // 处于连麦中 对应的流id
      chat_limit: '', // types.maybeNull(types.number)  聊天限制
      total_rank_switch: '1',
      live_end_time: 0,
      bg_url: '',
      title: '', // 开播主题
      greetings: '', // 开播问候语
      message: '', // 关播留言
      notify_msg: '', // 开播通知
      heat: 0, // 热度
      plebs_shield: false,
      hot_card_effect: false, // 热度卡生效
      // force_kiss

      live_stream_type: 0, // 0或空-个播 1-双人连麦 2-斗地主 3-多人房 4擂台赛 5-新版连麦 6-心跳pk
      live_streams: types.array(LiveStreamModel),
      now: 0,
      // DANCER 舞者，SINGER 歌手，APPEARANCE 颜值，DATING 交友
      certifications: types.array(CertificationsModel),
      // 即构 rtc_type:5，声网 rtc_type:9
      rtc_type: 0,
      client_type: '',
    })
    .views((self) => {
      return {
        get isRankVisible() {
          return !!self.total_rank_switch;
        },
        get isJoinLine() {
          return self.live_stream_type === 5;
        },
        get isHeartbeatPk() {
          return self.live_stream_type === 6;
        },
        get isRacePk() {
          return self.live_stream_type === 7;
        },
        get joinLineTimerText() {
          const now = self.now || getGlobalStore().getNow();
          const myMic = self.live_streams.find((item) => {
            return item.uid === self._id;
          });
          if (!myMic) {
            return '-';
          }

          return utils.getTimerText(Math.floor((now - myMic.voice_chat_join_time) / 1000));
        },
      };
    })
    .actions((self) => {
      const stopLive = () => {
        self.live_id = '';
        self.live = false;
        self.live_end_time = Date.now();
      };
      const runInAction = (cb) => {
        cb && cb(self);
      };
      const setNow = (timestamp) => {
        self.now = timestamp;
      };

      return {
        stopLive,
        runInAction,
        setNow,
      };
    }),
  {
    preProcessor(snapshot) {
      return {
        ...snapshot,
        live_id: `${snapshot.live_id || ''}`,
      };
    },
  },
);

const AllRoomInfoModel = types
  .model('AllRoomInfoModel', {
    _id: '',
    pk: types.maybeNull(PkModel),
    // 停播天数
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    return {};
  });

const LiveTypeModel = types.model('LiveTypeModel', {
  pc: false,
  mobile: false,
  vr: false,
  voice: false,
  official: false,
  ktv: false,
});

const Model = types
  .model({
    roomId: types.number,
    allRoomInfo: AllRoomInfoModel,
    roomInfo: RoomInfoModel,
    starInfo: UserModel,

    liveType: LiveTypeModel,

    isInitMusicInstance: false,
    complexSourceHandle: 0,
    refreshKey: 0,
    isKickOut: false,
    // 是否直推cdn
    isDirectToCdn: false,

    // medals:
  })
  .views((self) => {
    return {
      get isLive() {
        return self.roomInfo.live;
      },
      get isChatLimit() {
        return self.roomInfo.chat_limit === '1000';
      },
      get isRankVisible() {
        return self.roomInfo.total_rank_switch === '1';
      },
      get hasCover() {
        return !!self.roomInfo.app_pic_url; // 全部使用app_pic_url字段，统一成和客户端一致
      },
      get isRoomOwner() {
        const userId = getGlobalStore().userId;
        return userId && userId === self.roomId;
      },
      // 是否从pc开播
      get isStartLiveOnPc() {
        // 未开播的 在pc 打开走pc默认的开播流程
        return !self.isLive || self.liveType.pc;
      },
      // 在pc开播
      get isLiveOnPc() {
        return self.isLive && self.roomInfo.live_type > 0 && self.roomInfo.plugin > 0;
      },
      // pc 竖屏开播
      get isLiveOnPcPortrait() {
        return self.isLiveOnPc && self.roomInfo.plugin === 2;
      },
      // 在手机开播
      get isLiveOnMobile() {
        return self.isLive && self.roomInfo.live_type === 2 && self.roomInfo.plugin === 0;
      },
    };
  })
  .volatile((self) => {
    return {};
  })
  .actions((self) => {
    // let updateRoomInfo = (info) => {
    //   self.roomInfo = info;
    // }
    const update = flow(function* (id) {
      let res;
      try {
        const { group } = getStore();
        res = yield request.api.get(`public/room_star/${id || self.roomId}`);

        res.data.room.live_streams?.sort((a, b) => {
          if (a.uid === self.roomId) {
            return -1;
          }

          if (b.uid === self.roomId) {
            return 1;
          }
          return 0;
        });

        self.allRoomInfo = res.data;
        self.roomInfo = res.data.room;
        self.starInfo = res.data.user;
        self.roomId = res.data.user._id;

        getRtcStore().setRtcType(res.data.room.rtc_type);

        self.liveType = {
          pc: true,
        };

        group.update(res.data.group_info);

        // giftBottom.addUser({
        //   uid: self.starInfo._id,
        //   name: self.starInfo.nick_name,
        // });
        // giftBottom.setEnableMultipleSelect(false);

        log('update room success');
      } catch (e) {
        error('update room error', e);
      }
    });
    const updateRefreshKey = () => {
      self.refreshKey = Date.now();
    };
    const reload = (roomId) => {
      self.roomId = 0;
      update(roomId);
    };

    const runInAction = (cb) => {
      cb && cb(self);
    };

    const isRoomBroker = () => {
      return getGlobalStore().userId === get(self.starInfo, 'star.broker', '');
    };

    const setRoomInfo = (data) => {
      self.allRoomInfo = data;
      self.roomInfo = data.room;
      self.starInfo = data.user;
    };
    const updateMusicInstance = (status) => {
      self.isInitMusicInstance = status;
    };

    const stopLive = () => {
      self.isDirectToCdn = true;
      self.roomInfo.stopLive();
    };

    // const updateChatLimit = (value) => {
    //   self.roomInfo.chat_limit = value;
    // };

    const updateComplexSourceHandle = (handle) => {
      self.complexSourceHandle = handle;
    };

    const setKickOut = (status) => {
      self.isKickOut = status;
    };

    const setDirectToCdn = (status) => {
      self.isDirectToCdn = status;
    };

    return {
      update,
      reload,
      updateRefreshKey,
      setRoomInfo,
      runInAction,
      // isRoomOwner,
      // isLiveOnPc,
      // isLiveOnMobile,
      isRoomBroker,

      stopLive,
      updateMusicInstance,
      // updateChatLimit,
      updateComplexSourceHandle,
      setKickOut,
      setDirectToCdn,
    };
  });

export default {
  initState,
  Model,
};
